// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index.bundle." + "9cbe111fd0c065c94891" + ".js";
};